// extracted by mini-css-extract-plugin
export default {"infoWrapper":"ProcessComplete_infoWrapper__rnxjU"};